// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see FeatureEligibilityRetrieveStartedEvent
 */
export var FeatureEligibilityRetrieveStarted = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "FeatureEligibility Retrieve Started",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRetrieveSucceededEvent
 */
export var FeatureEligibilityRetrieveSucceeded = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber, localValues = _a.localValues, remoteValues = _a.remoteValues;
    return ({
        name: "FeatureEligibility Retrieve Succeeded",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            local_values: localValues !== undefined && localValues !== null ? localValues.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            remote_values: remoteValues !== undefined && remoteValues !== null ? remoteValues.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRetrieveUnchangedEvent
 */
export var FeatureEligibilityRetrieveUnchanged = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "FeatureEligibility Retrieve Unchanged",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRetrieveCanceledEvent
 */
export var FeatureEligibilityRetrieveCanceled = function (_a) {
    var reason = _a.reason, policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "FeatureEligibility Retrieve Canceled",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Retrieve",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRetrieveFailedEvent
 */
export var FeatureEligibilityRetrieveFailed = function (_a) {
    var reason = _a.reason, policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "FeatureEligibility Retrieve Failed",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Retrieve",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRefreshAttemptStartedEvent
 *
 * @deprecated Deprecated starting from 5.9.
 */
export var FeatureEligibilityRefreshAttemptStarted = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, refreshDelayBetweenRequestsInMillis = _a.refreshDelayBetweenRequestsInMillis, refreshRepeatCount = _a.refreshRepeatCount, attemptNumber = _a.attemptNumber;
    return ({
        name: "FeatureEligibility Refresh AttemptStarted",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Refresh",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refresh_delay_between_requests_in_millis: refreshDelayBetweenRequestsInMillis !== undefined && refreshDelayBetweenRequestsInMillis !== null ? refreshDelayBetweenRequestsInMillis.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refresh_repeat_count: refreshRepeatCount !== undefined && refreshRepeatCount !== null ? refreshRepeatCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FeatureEligibilityRefreshCompletedEvent
 *
 * @deprecated Deprecated starting from 5.9.
 */
export var FeatureEligibilityRefreshCompleted = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, refreshDelayBetweenRequestsInMillis = _a.refreshDelayBetweenRequestsInMillis, refreshRepeatCount = _a.refreshRepeatCount;
    return ({
        name: "FeatureEligibility Refresh Completed",
        parameters: {
            cdf_entity: "FeatureEligibility",
            cdf_action: "Refresh",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refresh_delay_between_requests_in_millis: refreshDelayBetweenRequestsInMillis !== undefined && refreshDelayBetweenRequestsInMillis !== null ? refreshDelayBetweenRequestsInMillis.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            refresh_repeat_count: refreshRepeatCount !== undefined && refreshRepeatCount !== null ? refreshRepeatCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
